import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import HotRecommendations from './components/HotRecommendations';
import LatestUpdates from './components/LatestUpdates';
import FAQSection from './components/FAQSection';
import { siteConfig } from '@/mocks/siteData';

export default function Home() {
  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: siteConfig.name,
    url: siteConfig.url,
    description: siteConfig.description,
    potentialAction: {
      '@type': 'SearchAction',
      target: `${siteConfig.url}/search?q={search_term_string}`,
      'query-input': 'required name=search_term_string',
    },
  };

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: siteConfig.name,
    url: siteConfig.url,
    description: siteConfig.description,
    email: siteConfig.email,
    telephone: siteConfig.phone,
    address: {
      '@type': 'PostalAddress',
      addressLocality: '北京',
      addressCountry: 'CN',
    },
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(websiteSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(orgSchema)}</script>

      <main>
        <HeroSection />
        <CategorySection />
        <HotRecommendations />
        <LatestUpdates />
        <FAQSection />
      </main>
    </>
  );
}